import { render, staticRenderFns } from "./AgeBandList.vue?vue&type=template&id=136492b4"
import script from "./AgeBandList.vue?vue&type=script&lang=js"
export * from "./AgeBandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports